import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { IUser, UserActionTypes } from "../models";
import { LOGIN } from "../types";

export default (data: { email: string, password: string}) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    dispatch({
        type: LOGIN,
        payload: {
            loading: true,
        },
    });
    try {
        const res = await api.post<{ user: IUser, success: boolean }>("/login", data);
        dispatch({
            type: LOGIN,
            payload: res,
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        dispatch({
            type: LOGIN,
            payload: {
                error: true,
            },
        });
    }
};
